import { QueryClient } from '@tanstack/react-query';

// Single shared QueryClient for the app.
//
// Defaults are tuned to mirror the pre-React-Query useEffect/useState
// hooks in CreateOrderV2: each hook fetched on input change, did not
// retry, and did not auto-refetch on focus or reconnect. We keep that
// behavior here so the swap is a no-op semantically.
//
// `staleTime: Infinity` means consumers get cached data on remount and
// only re-fetch when their query key changes (the same trigger the
// hand-rolled useEffects watched). Mutations elsewhere can call
// `queryClient.invalidateQueries({ queryKey: [...] })` to force a
// re-fetch — equivalent to the existing `refresh*()` helpers.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 5 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});
